module.exports = __webpack_public_path__ + "img/jim-anderson.1c9ccfad.png";